module.exports = __webpack_public_path__ + "f04d59f1b53b072519e2da2d2f28943c.svg";